export const MM_TO_M = 0.001;
export function mm(v: number): number { return v * MM_TO_M; }
